import { render, staticRenderFns } from "./Rider.vue?vue&type=template&id=efc20ee6&scoped=true&"
import script from "./Rider.vue?vue&type=script&lang=js&"
export * from "./Rider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc20ee6",
  null
  
)

export default component.exports